import React, { useContext, useEffect } from 'react';

import { SidebarContext } from '../../../layouts/Technician/index';

interface Props {}

const TechnicianJobs: React.FC<Props> = () => {
  const { currentPage, setCurrentPage } = useContext(SidebarContext);

  useEffect(() => {
    setCurrentPage('jobs');
  }, []);

  return (
    <>
      <div>งานในระบบ</div>
    </>
  );
};

export default TechnicianJobs;
